import { AppDeleteAccountScope } from 'mormaii-web-presentation/app-delete-account'
import { SignInScope } from 'mormaii-web-presentation/auth'
import { ForgotPasswordScope } from 'mormaii-web-presentation/forgot-password'
import type { ViewFactory } from 'wdc-cube-solid'

import { AppDeleteAccountView } from './v-app-delete-account'
import { ForgotPasswordView } from './v-forgot-password'
import { SignInView } from './v-sign-in'

/**
 * O conceito de conta: entrar, recuperar a senha e a pagina de exclusao que as
 * lojas apontam.
 *
 * Havia uma quarta, "criar conta", removida em 16/09/2026 - ver `B-22`. Nao ha
 * autoatendimento no painel: quem cria empresa e administrador dela e o
 * administrador geral, e quem cadastra profissional e o administrador da empresa.
 *
 * As tres compartilham as pecas de `components/account.tsx` - menos a de exclusao,
 * que nao e formulario - justamente para que quem vem da pagina que vende nao
 * sinta que trocou de produto no meio do caminho.
 */
export function registerViews(rv: typeof ViewFactory.register) {
    rv(SignInScope, SignInView)
    rv(ForgotPasswordScope, ForgotPasswordView)
    rv(AppDeleteAccountScope, AppDeleteAccountView)
}
